import { Navigate, useLocation } from 'react-router-dom';
import { useBeta } from '@/contexts/BetaContext';
import { useAuth } from '@/contexts/AuthContext';

const ALWAYS_PUBLIC = [
  '/beta', '/auth', '/privacy', '/terms', '/service-agreement', '/data-deletion',
  '/why/verified-agents', '/why/verified-properties', '/why/tracked-transactions',
  '/sitemap.xml',
];

export default function BetaGate({ children }) {
  const { betaMode, ready } = useBeta();
  const { user, token } = useAuth();
  const { pathname } = useLocation();

  if (!ready) return null;
  if (!betaMode) return children;
  if (token || user) return children;

  const isAllowed = ALWAYS_PUBLIC.some(p => pathname === p || pathname.startsWith(p + '/'));
  if (isAllowed) return children;
  return <Navigate to="/beta" replace />;
}
